import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-design',
  templateUrl: './design.component.html',
  styleUrls: [ './design.component.css' ]
})
export class DesignComponent implements OnInit {

  constructor(private _titleService: Title, private _metaService: Meta) { 
    this._titleService.setTitle("API Visual Design - Features - RestCase");
    this._metaService.addTags([
      {name: 'description', content: 'API visual design using WYSIWYG, quick and smart adds based on AI and machine learning algorithms.'}
    ], true);
  }

  ngOnInit() {
  }

}
